import { render, staticRenderFns } from "./EditTaskSettingsDialog.vue?vue&type=template&id=45a7f2b2&scoped=true&"
import script from "./EditTaskSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./EditTaskSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskSettingsDialog.vue?vue&type=style&index=0&id=45a7f2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7f2b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VCardText,VForm,VListItemContent,VListItemSubtitle,VListItemTitle,VSelect})
